import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dashSearch: { position: "relative" },
  searchIcon: {
    position: "absolute",
    right: "10px",
    top: "10px",
    color: "#999999",
  },
  input: {
    borderRadius: "0",
    backgroundColor: "#F2F2F24D",
    marginBottom: "1em",
  },
  tableBuyer: {
    minWidth: "100% !important",
    borderRadius: "0px !important",
    border: "1px solid #989898 !important",
    boxShadow: "none !important",
  },
  buyerRow: { backgroundColor: "#2D55EB", color: "#fff !important" },
  eye: { fontSize: "20px" },
  lots: {
    color: "#2D55EB",
    fontSize: "18px",
    marginLeft: "4px",
    marginBottom: "4px",
  },
  viewSelect: { height: "38px" },
  next: {
    width: "14em !important",
    borderRadius: "0em !important",
    // marginLeft: "1em !important",
    color: "#fff !important",
    backgroundColor: "#2D55EB !important",
  },
}));
export default useStyles;
